// import React, { useEffect, useRef, useState } from 'react';
// import { AudioVisualizer } from 'react-audio-visualize';

// /**
//  * AudioFilePlay
//  * - Accepts src as a string URL, Blob, or File
//  * - Ensures a Blob is provided to AudioVisualizer
//  * - Keeps visualizer in sync with actual playback via currentTime
//  */
// const AudioFilePlay = ({
//     src,
//     width = 300,
//     height = 100,
//     barWidth = 2,
//     gap = 1,
//     barColor = '#D8DBDF',
//     barPlayedColor = "#318EFF",
//     backgroundColor = 'transparent',
//     className,
//     style,
// }) => {
//     const audioRef = useRef(null);
//     const [blob, setBlob] = useState(null);
//     const [objectUrl, setObjectUrl] = useState(null);
//     const [isPlaying, setIsPlaying] = useState(false);
//     const [currentTime, setCurrentTime] = useState(0);

//     // Create blob from src (if needed)
//     useEffect(() => {
//         let cancelled = false;

//         async function ensureBlob(input) {
//             if (!input) {
//                 setBlob(null);
//                 return;
//             }

//             // If File/Blob already, use directly
//             if (input instanceof Blob) {
//                 if (input.type && input.type.startsWith('audio/')) {
//                     setBlob(input);
//                 } else {
//                     // Not an audio blob; do not attempt to visualize
//                     setBlob(null);
//                     // console.warn('Provided Blob is not audio. type=', input.type);
//                 }
//                 return;
//             }

//             // If string URL, try to fetch to Blob
//             if (typeof input === 'string') {
//                 try {
//                     const res = await fetch(input, { mode: 'cors' });
//                     if (!res.ok) throw new Error('Failed to fetch audio');
//                     const ct = res.headers.get('content-type') || '';
//                     if (!ct.toLowerCase().startsWith('audio/')) {
//                         // Might be HTML error page or unsupported type
//                         if (!cancelled) setBlob(null);
//                         return;
//                     }
//                     const b = await res.blob();
//                     if (b && (!b.type || b.type.startsWith('audio/'))) {
//                         if (!cancelled) setBlob(b);
//                     } else {
//                         if (!cancelled) setBlob(null);
//                     }
//                 } catch (e) {
//                     // If fetch fails (e.g., CORS), we cannot provide a Blob for the visualizer.
//                     // Fallback: clear blob so we only render the audio element.
//                     if (!cancelled) setBlob(null);
//                     // Optionally you could log e for debugging.
//                 }
//                 return;
//             }

//             // Unknown type
//             setBlob(null);
//         }

//         ensureBlob(src);

//         return () => {
//             cancelled = true;
//         };
//     }, [src]);

//     // Create object URL for audio element from the blob for consistent data source
//     useEffect(() => {
//         let url = null;
//         if (blob instanceof Blob) {
//             url = URL.createObjectURL(blob);
//             setObjectUrl(url);
//         } else if (typeof src === 'string') {
//             // If we couldn't create a blob (e.g., CORS), fall back to raw string URL
//             setObjectUrl(src || null);
//         } else {
//             setObjectUrl(null);
//         }
//         return () => {
//             if (url) URL.revokeObjectURL(url);
//         };
//     }, [blob, src]);

//     // Wire up audio element events
//     useEffect(() => {
//         const audio = audioRef.current;
//         if (!audio) return;

//         const onTimeUpdate = () => setCurrentTime(audio.currentTime || 0);
//         const onPlay = () => setIsPlaying(true);
//         const onPause = () => setIsPlaying(false);
//         const onEnded = () => setIsPlaying(false);

//         audio.addEventListener('timeupdate', onTimeUpdate);
//         audio.addEventListener('play', onPlay);
//         audio.addEventListener('pause', onPause);
//         audio.addEventListener('ended', onEnded);

//         return () => {
//             audio.removeEventListener('timeupdate', onTimeUpdate);
//             audio.removeEventListener('play', onPlay);
//             audio.removeEventListener('pause', onPause);
//             audio.removeEventListener('ended', onEnded);
//         };
//     }, [objectUrl]);

//     const togglePlay = async () => {
//         console.log('togglePlay');
//         const audio = audioRef.current;
//         if (!audio) return;
//         if (audio.paused) {
//             try {
//                 await audio.play();
//             } catch (e) {
//                 // Autoplay may be blocked; user interaction should trigger play
//             }
//         } else {
//             audio.pause();
//         }
//     };

//     const canVisualize = !!blob; // Only show visualizer when we have a Blob

//     return (
//         <div className={`flex items-center justify-between gap-2 ${className}`} style={style}>
//             <div className='flex gap-2 items-center w-[25%]'>
//                 <button type="button" onClick={togglePlay} id={'playIcon'} disabled={!objectUrl}>
//                     {isPlaying ? <div className='pauseIconGray w-6 h-6 pointer-events-none'></div> : <div className='w-6 h-6 playIconGray pointer-events-none'></div>}
//                 </button>
//                 <p className='text-sm text-text-body'>Audio</p>
//                 <audio className='hidden' ref={audioRef} src={objectUrl || undefined} preload="metadata" />
//             </div>

//             <div className='audio-visualizer-canvas w-[67%]'>
//                 {canVisualize && (
//                     <AudioVisualizer
//                         blob={blob}
//                         width={width}
//                         height={height}
//                         barWidth={barWidth}
//                         gap={gap}
//                         backgroundColor={backgroundColor}
//                         barColor={barColor}
//                         {...(barPlayedColor ? { barPlayedColor } : {})}
//                         currentTime={currentTime}
//                     />
//                 )}
//             </div>
//             <div className='w-[8%]'>
//                 <div className='bg-gray-200 rounded-full p-1 w-6 h-6'>
//                     <div className='singlePeopleGray w-4 h-4' style={{ backgroundSize: "20px" }}> </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AudioFilePlay;



import React, { useState, useRef, useEffect, useCallback } from "react";
import PalyIcon from "../../../media/icons/assets_light/outline-audio-play-active.svg";
import PauseIcon from "../../../media/icons/assets_light/outline-audio-pause-active.svg";
import UserIcon from "../../../media/icons/assets_light/outline-management-person.svg";

export default function AudioFilePlay({ url }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioContextRef = useRef(null);
  const audioRef = useRef(null);
  const canvasRef = useRef(null);
  const animationFrameRef = useRef(null);

  // Initialize audio context
  useEffect(() => {
    if (!url) return;

    try {
      const context = new (window.AudioContext || window.webkitAudioContext)();
      audioContextRef.current = context;
    } catch (err) {
      console.error("Error initializing audio:", err);
    }

    return () => {
      if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
      if (audioContextRef.current) {
        audioContextRef.current.close();
        audioContextRef.current = null;
      }
    };
  }, [url]);

  // --- Draw static waveform with colored progress ---
  // Draw a single frame
  const drawFrame = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const WIDTH = canvas.width;
    const HEIGHT = canvas.height;

    ctx.clearRect(0, 0, WIDTH, HEIGHT);

    const totalBars = 30; // number of bars
    const barGap = 4;
    const barWidth = (WIDTH - (totalBars - 1) * barGap) / totalBars;

    const duration = audioRef.current?.duration || 0;
    const currentTime = audioRef.current?.currentTime || 0;
    const progressRatio = duration ? currentTime / duration : 0;

    for (let i = 0; i < totalBars; i++) {
      const barProgress = (i + 1) / totalBars;

      // fixed waveform shape (like sine-based pattern)
      const baseHeight = (Math.sin(i * 0.6) * 0.5 + 0.5) * HEIGHT * 0.7;
      const x = i * (barWidth + barGap);
      const y = HEIGHT / 2 - baseHeight / 2;

      // Blue if within progress, gray otherwise
      ctx.fillStyle = barProgress <= progressRatio ? "#65ABA6" : "#d1d5db";
      ctx.fillRect(x, y, barWidth, baseHeight);
    }
  }, []);

  // Looping draw
  const startLoop = useCallback(() => {
    drawFrame();
    animationFrameRef.current = requestAnimationFrame(startLoop);
  }, [drawFrame]);

  // Keep waveform redrawing as audio plays
  useEffect(() => {
    if (isPlaying) {
      startLoop();
      return () => {
        if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
      };
    } else {
      if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
      drawFrame(); // draw a static frame when paused
    }
  }, [isPlaying, startLoop, drawFrame]);

  // Toggle play/pause
  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio
        .play()
        .then(() => setIsPlaying(true))
        .catch((err) => console.error("Play failed:", err));
    }
  };

  // Resume audio context on click (browser restriction)
  const resumeAudioContext = async () => {
    const audioContext = audioContextRef.current;
    if (audioContext && audioContext.state === "suspended") {
      await audioContext.resume();
    }
  };

  return (
    <div className="w-full h-[60px] px-3 flex items-center justify-between">
      <button
        onClick={togglePlay}
        onMouseDown={resumeAudioContext}
        className="w-7 h-7 flex items-center justify-center bg-teal-600 text-white rounded-full hover:bg-[#98DED9] transition-colors"
      >
        {isPlaying ? (
          <span
            className="w-[20px] h-[20px] bg-white"
            style={{
              WebkitMaskImage: `url(${PauseIcon})`,
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              WebkitMaskSize: "contain",
              maskImage: `url(${PauseIcon})`,
              maskRepeat: "no-repeat",
              maskPosition: "center",
              maskSize: "contain",
            }}
          />
        ) : (
          <span
            className="w-[20px] h-[20px] bg-white"
            style={{
              WebkitMaskImage: `url(${PalyIcon})`,
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              WebkitMaskSize: "contain",
              maskImage: `url(${PalyIcon})`,
              maskRepeat: "no-repeat",
              maskPosition: "center",
              maskSize: "contain",
            }}
          />
        )}
      </button>

      {/* Label */}
      <div className="text-text-body font-medium text-sm ml-2 dark:text-white">Audio</div>

      {/* Canvas Waveform */}
      <div className="flex-1 mx-4">
        <canvas ref={canvasRef} width={200} height={30} className="w-full h-full" />
      </div>

      {/* User Icon */}
      <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
        <span
          className="w-[20px] h-[20px] bg-[#636E82]"
          style={{
            WebkitMaskImage: `url(${UserIcon})`,
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            WebkitMaskSize: "contain",
            maskImage: `url(${UserIcon})`,
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: "contain",
          }}
        />
      </div>

      {/* Hidden Audio Element */}
      <audio
        ref={audioRef}
        src={url}
        onEnded={() => setIsPlaying(false)}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        style={{ display: "none" }}
        crossOrigin="anonymous"
      />
    </div>
  );
}